var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"property_item column flex flex-vertical-center",class:[_vm.columnClass]},[_c('p',{staticClass:"property_item--label"},[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),_c('p',{staticClass:"property_item--value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }